import React from 'react';
import { useIntegrationsRecommendation } from './hooks/useIntegrationsRecommendation';
import { AppsSlider } from './components/AppsSlider';
export const IntegrationsRecommendation = () => {
    const { apps } = useIntegrationsRecommendation();
    if (!apps || !apps.length)
        return null;
    return React.createElement(AppsSlider, { heading: "Apps to help your growth", apps: apps });
};
